import axios, { AxiosResponse } from "axios";
import { AppError } from "../errors/app-errors";
import { store } from "../app/store";
import { VIPER_URL } from "../commonConstant";
import { router } from "../router";


const appAxios = axios.create({
  baseURL: VIPER_URL,
});

appAxios.interceptors.request.use((conf) => {
  const user = store.getState().auth;
  if (user?.authStatus) {
    conf.headers = {
      ...conf.headers,
      // Authorization: `Bearer ${auth}`,
    } as any;
  }
  return conf;
});
appAxios.interceptors.response.use(
  (resp) => {
    if (resp.status === 401) {
      router.navigate("/login", {
        replace: true,
      });
    }
    return resp;
  },
  (err) => {
    if (err?.response?.status === 401) {
      router.navigate("/login", {
        replace: true,
      });
      throw new AppError(
        401,
        "Your session has expired. Please login to continue..."
      );
    }
    throw err;
  }
);

export const _post = async <T>(api: string, data: any, headers: any = null) => {
  try {
    let response: AxiosResponse<T, any>;
    if (headers) {
      response = await appAxios.post<T>(api, data, {
        headers,
      });
    } else {
      response = await appAxios.post<T>(api, data);
    }
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      throw new AppError(response.status, response.statusText, response.data);
    }
  } catch (error) {
    console.error(error);
  }
  
};
export { appAxios };
